module.exports = __webpack_public_path__ + "assets/img/9e6c-gt.svg";